import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'

export default defineNuxtRouteMiddleware(() => {
  if (!process.client)
    return

  const isSystem = localStorage.getItem('is_system') === '1'
  let permissions: string[] = []
  try {
    const parsed = JSON.parse(localStorage.getItem('system_permissions') || '[]')
    permissions = Array.isArray(parsed) ? parsed : []
  }
  catch {
    permissions = []
  }

  if (!isSystem && !permissions.includes('support.view'))
    return navigateTo('/personal')
})
